// FETCH ALL BILL_PAYMENT_DETAILS
export const FETCH_BILL_PAYMENT_DETAILS_REQUEST = 'FETCH_BILL_PAYMENT_DETAILS_REQUEST';
export const FETCH_BILL_PAYMENT_DETAILS_SUCCESS = 'FETCH_BILL_PAYMENT_DETAILS_SUCCESS';
export const FETCH_BILL_PAYMENT_DETAILS_FAILURE = 'FETCH_BILL_PAYMENT_DETAILS_FAILURE';

// FETCH ALL BILL_PAYMENT_DETAILS
export const FETCH_BILL_PAYMENT_DETAILS_WITHOUT_ID_REQUEST = 'FETCH_BILL_PAYMENT_DETAILS_WITHOUT_ID_REQUEST';
export const FETCH_BILL_PAYMENT_DETAILS_WITHOUT_ID_SUCCESS = 'FETCH_BILL_PAYMENT_DETAILS_WITHOUT_ID_SUCCESS';
export const FETCH_BILL_PAYMENT_DETAILS_WITHOUT_ID_FAILURE = 'FETCH_BILL_PAYMENT_DETAILS_WITHOUT_ID_FAILURE';

// CREATE BILL_PAYMENT_DETAILS
export const CREATE_BILL_PAYMENT_DETAILS_REQUEST = 'CREATE_BILL_PAYMENT_DETAILS_REQUEST';
export const CREATE_BILL_PAYMENT_DETAILS_SUCCESS = 'CREATE_BILL_PAYMENT_DETAILS_SUCCESS';
export const CREATE_BILL_PAYMENT_DETAILS_FAILURE = 'CREATE_BILL_PAYMENT_DETAILS_FAILURE';

// UPDATE BILL_PAYMENT_DETAILS
export const UPDATE_BILL_PAYMENT_DETAILS_REQUEST = 'UPDATE_BILL_PAYMENT_DETAILS_REQUEST';
export const UPDATE_BILL_PAYMENT_DETAILS_SUCCESS = 'UPDATE_BILL_PAYMENT_DETAILS_SUCCESS';
export const UPDATE_BILL_PAYMENT_DETAILS_FAILURE = 'UPDATE_BILL_PAYMENT_DETAILS_FAILURE';

// FETCH SINGLE STATE OF BILL_PAYMENT_DETAILS
export const FETCH_SINGLE_BILL_PAYMENT_DETAILS_REQUEST = 'FETCH_SINGLE_BILL_PAYMENT_DETAILS_REQUEST';
export const FETCH_SINGLE_BILL_PAYMENT_DETAILS_SUCCESS = 'FETCH_SINGLE_BILL_PAYMENT_DETAILS_SUCCESS';
export const FETCH_SINGLE_BILL_PAYMENT_DETAILS_FAILURE = 'FETCH_SINGLE_BILL_PAYMENT_DETAILS_FAILURE';

// DELETE BILL_PAYMENT_DETAILS
export const DELETE_BILL_PAYMENT_DETAILS_REQUEST = 'DELETE_BILL_PAYMENT_DETAILS_REQUEST';
export const DELETE_BILL_PAYMENT_DETAILS_SUCCESS = 'DELETE_BILL_PAYMENT_DETAILS_SUCCESS';
export const DELETE_BILL_PAYMENT_DETAILS_FAILURE = 'DELETE_BILL_PAYMENT_DETAILS_FAILURE';

export const RESET_BILL_PAYMENT_DETAILS_INFO = 'RESET_BILL_PAYMENT_DETAILS_INFO';
export const RESET_BILL_PAYMENT_DETAILS = 'RESET_BILL_PAYMENT_DETAILS';

export const CREATE_BILL_PAYMENT_DETAILS_FORM = 'CREATE_BILL_PAYMENT_DETAILS_FORM';

export const UPDATE_BILL_PAYMENT_DETAILS_FORM = 'UPDATE_BILL_PAYMENT_DETAILS_FORM';
